import { HTMLAttributes } from "react";

import * as S from "./Avatar.style";

interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  profile: {
    url?: string;
    id?: number;
  };
  withBorder?: boolean;
  blur?: boolean;
  size?: S.AvatarSizeType;
}

const Avatar = ({
  profile,
  withBorder = false,
  blur = false,
  size = "s",
  ...rest
}: AvatarProps) => {
  return (
    <S.AvatarWrapper $withBorder={withBorder} $size={size} {...rest}>
      <S.Avatar
        $blur={blur}
        src={profile?.url || "/assets/image_default9.png"}
        alt={`User-${profile?.id}`}
        width={0}
        height={0}
        sizes={`${S.AVATAR_SIZE[size] * 2}px`}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </S.AvatarWrapper>
  );
};

export default Avatar;
